import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';
import FooterMenu from '../FooterMenu';
import FooterText from '../FooterText';

const FooterColumn = ({
  column,
  ctaClasses = 'btn btn--s btn--secondary',
  analyticData,
}) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();

  const renderColumn = () => {
    return column.map((item, index) => {
      const type = item.type[0].target_id;
      let component = '';
      switch (type) {
        case 'links':
          component = (
            <FooterMenu
              key={`${type}-${item.id[0].value}`}
              heading={
                item.field_headline.length
                  ? item.field_headline[0].processed
                  : ''
              }
              id={item.id[0].value}
              list={item.field_links}
              analyticData={analyticData && analyticData?.navClicked}
            />
          );
          break;
        case 'cta_link':
          component = (
            <a
              key={`${type}-${index}`}
              className={ctaClasses}
              href={item.field_cta.length ? item.field_cta[0].url : ''}
              onClick={(e) =>
                analyticData?.navClicked &&
                pushAnalyticEvent({
                  ...analyticData.navClicked,
                  component_name: '[B47] CTA Link',
                  link_text: item.field_cta.length
                    ? item.field_cta[0].title
                    : '',
                  link_url: e.target.href,
                })
              }
            >
              {item.field_cta.length ? item.field_cta[0].title : ''}
            </a>
          );
          break;
        case 'text':
          component = (
            <FooterText
              key={`${type}-${item.id[0].value}`}
              heading={
                item.field_headline.length
                  ? item.field_headline[0].processed
                  : ''
              }
              text={item.field_body.length ? item.field_body[0].processed : ''}
              analyticData={analyticData && analyticData?.navClicked}
            />
          );
          break;
        default:
          component = '';
      }
      return component;
    });
  };

  return <>{renderColumn()}</>;
};

export default FooterColumn;
